



































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";
import { storePenerimaanPasienBaruRanap } from "@/store/modules/PenerimaanPasienBaruRanapStore";
import PenerimaanPasienBaruRanapSvc from "@/services/PenerimaanPasienBaruRanap";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import { getHumanDateTime } from "@/utility/DateUtils";

@Component({
  components: { CardModalTtd, PersonAutoComplete },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardPenerimaanPasienBaruRanap extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean { return this.isReadOnly(); }

  isEditing = false;
  modalTtd = false;
  deleting = false;
  saving = false;
  formValid = false;

  kelasOptions = ["Kelas 1", "Kelas 2", "Kelas 3", "VIP", "VVIP", "Isolasi", "Intensif"];
  hubunganOptions = ["Diri sendiri", "Suami", "Istri", "Anak", "Ayah", "Ibu", "Saudara kandung", "Wali", "Lainnya"];

  fasilitasOptions = [
    { value: "tempat_tidur", label: "Tempat tidur & posisi (head up/down)" },
    { value: "lemari", label: "Lemari pakaian / nakas" },
    { value: "kamar_mandi", label: "Kamar mandi & toilet" },
    { value: "bel_panggilan", label: "Bel panggilan perawat" },
    { value: "tv", label: "Televisi (sesuai kelas)" },
    { value: "ac", label: "AC / Kipas / Ventilasi" },
    { value: "dispenser", label: "Dispenser / air minum" },
    { value: "jendela_tirai", label: "Jendela / tirai privasi" },
    { value: "wifi", label: "WiFi RS (sesuai kelas)" },
    { value: "pantry", label: "Pantry / dapur keluarga" },
    { value: "ruang_tunggu", label: "Ruang tunggu keluarga" }
  ];

  keselamatanOptions = [
    { value: "apar", label: "Lokasi APAR (Alat Pemadam Api Ringan)" },
    { value: "jalur_evakuasi", label: "Jalur evakuasi terdekat" },
    { value: "titik_kumpul", label: "Titik kumpul saat bencana" },
    { value: "code_blue", label: "Cara aktivasi Code Blue (kegawatdaruratan)" },
    { value: "gelang_identitas", label: "Gelang identitas pasien (SKP 1)" },
    { value: "gelang_risiko", label: "Gelang risiko (jatuh/alergi/DNR)" },
    { value: "pencegahan_jatuh", label: "Pencegahan pasien jatuh (SKP 6)" }
  ];

  hakKewajibanOptions = [
    { value: "hak_pasien", label: "Hak pasien (UU 17/2023 Ps. 276 + UU RS)" },
    { value: "kewajiban_pasien", label: "Kewajiban pasien (UU 17/2023 Ps. 277)" },
    { value: "general_consent", label: "Persetujuan Umum (General Consent) telah ditandatangani" },
    { value: "privasi_kerahasiaan", label: "Privasi & kerahasiaan data (UU PDP)" },
    { value: "second_opinion", label: "Hak meminta pendapat dokter lain (second opinion)" },
    { value: "menolak_tindakan", label: "Hak menolak tindakan medis" },
    { value: "komplain", label: "Mekanisme penyampaian keluhan / komplain" },
    { value: "rohani", label: "Hak pelayanan kerohanian" }
  ];

  tataTertibOptions = [
    { value: "jam_besuk", label: "Jam besuk pengunjung" },
    { value: "penunggu_satu_orang", label: "Penunggu pasien maks. 1 orang (kecuali bayi/anak/intensif)" },
    { value: "gelang_pengunjung", label: "Penunggu memakai kartu/gelang penunggu" },
    { value: "larangan_anak_kecil", label: "Anak < 12 tahun dilarang masuk ruang rawat" },
    { value: "larangan_merokok", label: "Larangan merokok di seluruh kawasan RS (KTR)" },
    { value: "larangan_makanan_luar", label: "Larangan makanan dari luar tanpa izin ahli gizi" },
    { value: "larangan_alat_elektronik", label: "Pembatasan alat elektronik berdaya tinggi" },
    { value: "titip_barang_berharga", label: "Anjuran tidak menyimpan barang berharga di kamar" }
  ];

  edukasiAwalOptions = [
    { value: "cuci_tangan_5moments", label: "Cuci tangan 6 langkah & 5 Moments WHO (PPI)" },
    { value: "identifikasi_gelang", label: "Identifikasi pasien dengan gelang (2 identitas — SKP 1)" },
    { value: "manajemen_nyeri", label: "Cara melaporkan & skala nyeri (NRS / Wong-Baker)" },
    { value: "pencegahan_jatuh", label: "Pencegahan jatuh (SKP 6) — pagar tempat tidur" },
    { value: "komunikasi_keluarga", label: "Komunikasi dengan PPA & keluarga (SBAR)" },
    { value: "etika_batuk", label: "Etika batuk & masker (PPI)" },
    { value: "mobilisasi_dini", label: "Mobilisasi dini & latihan napas" }
  ];

  form: any = this.getEmptyForm();

  mounted() {
    storePenerimaanPasienBaruRanap.getByRegister(this.register);
  }

  getEmptyForm() {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    const hh = String(today.getHours()).padStart(2, "0");
    const mi = String(today.getMinutes()).padStart(2, "0");
    return {
      tgl_masuk_bangsal: `${yyyy}-${mm}-${dd}`,
      jam_masuk_bangsal: `${hh}:${mi}`,
      bangsal: "",
      kelas: "",
      no_tempat_tidur: "",
      penerima_nama: "",
      penerima_hubungan: "",
      penerima_hubungan_lainnya: "",
      dpjp_utama_nama: "",
      dpjp_utama_spesialis: "",
      perawat_pp_nama: "",
      mpp_nama: "",
      jadwal_visite: "Senin-Jumat 07:00-09:00; Sabtu 08:00-09:00",
      jam_besuk_pagi: "11:00-13:00",
      jam_besuk_sore: "17:00-19:00",
      maksimal_pengunjung: 2,
      fasilitas: [],
      keselamatan: [],
      hak_kewajiban: [],
      tata_tertib: [],
      edukasi_awal: [],
      catatan_orientasi: "",
      kendala_pemahaman: "",
      tempat_tanda_tangan: "Bantul"
    };
  }

  labelOf(opts: any[], val: string): string {
    const item = opts.find(o => o.value === val);
    return item ? item.label : val;
  }

  formatDate(date) {
    if (!date) return "";
    const d = new Date(date);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  }

  formatTime(t: string) {
    if (!t) return "";
    return t.substring(0, 5);
  }

  formatDateTime(date) { return getHumanDateTime(date); }

  get stateData() { return storePenerimaanPasienBaruRanap.penerimaan; }
  get canMakeForm() { return !this.readOnly; }
  get canEdit() {
    if (this.readOnly) return false;
    if (!this.stateData) return false;
    return !this.stateData.signed_petugas;
  }
  get canDelete() {
    if (this.readOnly) return false;
    if (!this.stateData) return false;
    return !alasanTtdMengunciHapus(
      this.stateData.creator_user_id,
      [{ ditandatangani: this.stateData.signed_petugas, penandaTanganId: this.stateData.petugas_id }],
      userModule.user?.id
    );
  }
  get canSignPetugas() {
    if (this.readOnly) return false;
    return this.stateData && !this.stateData.signed_petugas;
  }

  startEdit() {
    const c = this.stateData;
    this.form = {
      tgl_masuk_bangsal: c.tgl_masuk_bangsal || "",
      jam_masuk_bangsal: (c.jam_masuk_bangsal || "").substring(0, 5),
      bangsal: c.bangsal || "",
      kelas: c.kelas || "",
      no_tempat_tidur: c.no_tempat_tidur || "",
      penerima_nama: c.penerima_nama || "",
      penerima_hubungan: c.penerima_hubungan || "",
      penerima_hubungan_lainnya: c.penerima_hubungan_lainnya || "",
      dpjp_utama_nama: c.dpjp_utama_nama || "",
      dpjp_utama_spesialis: c.dpjp_utama_spesialis || "",
      perawat_pp_nama: c.perawat_pp_nama || "",
      mpp_nama: c.mpp_nama || "",
      jadwal_visite: c.jadwal_visite || "",
      jam_besuk_pagi: c.jam_besuk_pagi || "",
      jam_besuk_sore: c.jam_besuk_sore || "",
      maksimal_pengunjung: c.maksimal_pengunjung || 2,
      fasilitas: c.fasilitas || [],
      keselamatan: c.keselamatan || [],
      hak_kewajiban: c.hak_kewajiban || [],
      tata_tertib: c.tata_tertib || [],
      edukasi_awal: c.edukasi_awal || [],
      catatan_orientasi: c.catatan_orientasi || "",
      kendala_pemahaman: c.kendala_pemahaman || "",
      tempat_tanda_tangan: c.tempat_tanda_tangan || "Bantul"
    };
    this.isEditing = true;
  }

  cancelEdit() {
    this.isEditing = false;
    this.form = this.getEmptyForm();
  }

  async simpan() {
    if (!(this.$refs.formPpb as any).validate()) return;
    this.saving = true;
    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        ...this.form,
        penerima_hubungan_lainnya: this.form.penerima_hubungan === "Lainnya" ? this.form.penerima_hubungan_lainnya : null
      };

      let resp;
      if (this.stateData && this.isEditing) {
        resp = await PenerimaanPasienBaruRanapSvc.update(this.stateData.id, payload);
      } else {
        resp = await PenerimaanPasienBaruRanapSvc.create(payload);
      }

      if (resp.data.status == "1") {
        appModule.NoticeDelay("Form Penerimaan Pasien Baru berhasil disimpan");
        this.isEditing = false;
        this.form = this.getEmptyForm();
        storePenerimaanPasienBaruRanap.getByRegister(this.register);
      }
    } finally {
      this.saving = false;
    }
  }

  openTtd() { this.modalTtd = true; }

  async passTtd(password: string) {
    const resp = await PenerimaanPasienBaruRanapSvc.signPetugas(this.stateData.id, { password });
    if (resp.data.status == "1") {
      this.modalTtd = false;
      appModule.NoticeDelay("Berhasil Tanda Tangan Petugas Orientasi");
      appModule.addMsgTtd("");
      storePenerimaanPasienBaruRanap.getByRegister(this.register);
    } else {
      appModule.addMsgTtd(resp.data.message);
      this.modalTtd = true;
    }
  }

  cetakPdf() { PenerimaanPasienBaruRanapSvc.print(this.stateData.id); }

  async remove() {
    if (!this.canDelete) return;
    const q = confirm("Anda yakin akan menghapus Form Penerimaan Pasien Baru ini?");
    if (q && !this.deleting) {
      this.deleting = true;
      try {
        const resp = await PenerimaanPasienBaruRanapSvc.destroy(this.stateData.id);
        if (resp?.status == 1) {
          appModule.NoticeDelay(resp.message);
          storePenerimaanPasienBaruRanap.getByRegister(this.register);
        }
      } finally {
        this.deleting = false;
      }
    }
  }
}
